// Customer session token storage. Mirrors utils/referralCode.js:
// window/localStorage access is fully guarded (Safari private mode,
// quota, enterprise policy all throw). The token is a signed,
// non-secret-bearing session token from POST /auth/verify-code/; it
// lives in localStorage and is sent in the Authorization header
// (NEVER a cookie — that would reintroduce CSRF).
const STORAGE_KEY = "pxn_auth_token";

/** The current session token, or null. */
export function getToken() {
  if (typeof window === "undefined" || !window.localStorage) return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY) || null;
  } catch (_e) {
    return null;
  }
}

/** Persist the session token after a successful verify. */
export function setToken(token) {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch (_e) {
    // Storage quota / private mode; ignore.
  }
}

/** Drop the token (sign out / 401). */
export function clearToken() {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (_e) {
    // ignore
  }
}

/** Convenience for non-interceptor callers that build headers by hand. */
export function authHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
